import * as types from "../../actionTypes/Dashboard/eurailTicketActionTypes";

const initial = {
  ETStationList: {},
  ETStationToList: {},
  EurailTicketSearch: {},
  GetEurailTicketList: {},
  EurailTicketPreBookDetails: {},
  EurailTicketCheckoutDetails: {},
  GetEurailConfigKey: {},
  EurailBookingDetailsByBid: "",
  AgentEurailBookingDetailsByBid: "",
  GetHSID: {},
  EurailSegmentCharges: "",
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const EurailTicketReducer = (state = initial, action: any) => {
  switch (action.type) {
    // ------------------> EURAIL_STATION_LIST start
    case types.EURAIL_STATION_LIST.FULLFILLED:
      return { ...state, ETStationList: action.payload };
    case types.EURAIL_STATION_LIST.REJECTED:
      return { ...state, ETStationList: {} };
    // ------------------> EURAIL_STATION_LIST end
    // ------------------> EURAIL_STATION_TO_LIST start
    case types.EURAIL_STATION_TO_LIST.FULLFILLED:
      return { ...state, ETStationToList: action.payload };
    case types.EURAIL_STATION_TO_LIST.REJECTED:
      return { ...state, ETStationToList: {} };
    // ------------------> EURAIL_STATION_TO_LIST end

    // ------------------> EURAIL_TICKET_SEARCH start
    case types.EURAIL_TICKET_SEARCH.FULLFILLED:
      return { ...state, EurailTicketSearch: action.payload };
    case types.EURAIL_TICKET_SEARCH.REJECTED:
      return { ...state, EurailTicketSearch: {} };
    // ------------------> EURAIL_TICKET_SEARCH end

    // ------------------> GET_EURAIL_TICKET_LIST start
    case types.GET_EURAIL_TICKET_LIST.FULLFILLED:
      return { ...state, GetEurailTicketList: action.payload };
    case types.GET_EURAIL_TICKET_LIST.REJECTED:
      return { ...state, GetEurailTicketList: {} };
    // ------------------> GET_EURAIL_TICKET_LIST end

    // ------------------> AGENT_GET_EURAIL_TICKET_HSID start
    case types.GET_EURAIL_TICKET_HSID.FULLFILLED:
      return { ...state, GetHSID: action.payload };
    case types.GET_EURAIL_TICKET_HSID.REJECTED:
      return { ...state, GetHSID: "" };
    // ------------------> AGENT_GET_EURAIL_TICKET_HSID end

    // ------------------> EURAIL_TICKET_PRE_BOOK start
    case types.EURAIL_TICKET_PRE_BOOK.FULLFILLED:
      return { ...state, EurailTicketPreBookDetails: action.payload };
    case types.EURAIL_TICKET_PRE_BOOK.REJECTED:
      return { ...state, EurailTicketPreBookDetails: {} };
    // ------------------> EURAIL_TICKET_PRE_BOOK end

    // ------------------> EURAIL_TICKET_CHECKOUT start
    case types.EURAIL_TICKET_CHECKOUT.FULLFILLED:
      return { ...state, EurailTicketCheckoutDetails: action.payload };
    case types.EURAIL_TICKET_CHECKOUT.REJECTED:
      return { ...state, EurailTicketCheckoutDetails: {} };
    // ------------------> EURAIL_TICKET_CHECKOUT end

    // ------------------> EURAIL_CONFIG_KEY start
    case types.EURAIL_CONFIG_KEY.FULLFILLED:
      return { ...state, GetEurailConfigKey: action.payload };
    case types.EURAIL_CONFIG_KEY.REJECTED:
      return { ...state, GetEurailConfigKey: {} };
    // ------------------> EURAIL_CONFIG_KEY end

    // ------------------> GET_EURAIL_BOOKING_DETAILS start
    case types.GET_EURAIL_BOOKING_DETAILS.FULLFILLED:
      return { ...state, EurailBookingDetailsByBid: action.payload };
    case types.GET_EURAIL_BOOKING_DETAILS.REJECTED:
      return { ...state, EurailBookingDetailsByBid: "" };
    // ------------------> GET_EURAIL_BOOKING_DETAILS end

    // ------------------> AGENT_GET_EURAIL_BOOKING_DETAILS start
    case types.AGENT_GET_EURAIL_BOOKING_DETAILS.FULLFILLED:
      return { ...state, AgentEurailBookingDetailsByBid: action.payload };
    case types.AGENT_GET_EURAIL_BOOKING_DETAILS.REJECTED:
      return { ...state, AgentEurailBookingDetailsByBid: "" };
    // ------------------> AGENT_GET_EURAIL_BOOKING_DETAILS end

    // ------------------> EURAIL_SEGMENT_CHARGES start
    case types.EURAIL_SEGMENT_CHARGES.FULLFILLED:
      return {
        ...state,
        EurailSegmentCharges: action.payload,
      };

    case types.EURAIL_SEGMENT_CHARGES.REJECTED:
      return {
        ...state,
        EurailSegmentCharges: {},
      };
    // ------------------> EURAIL_SEGMENT_CHARGES end

    case "clear_EurailTicketList": {
      return { ...state, GetEurailTicketList: {} };
    }
    default:
      return state;
  }
};

export default EurailTicketReducer;
